import Toolbox from "./components/Toolbox";
import "../../Index.scss";
import TopSection from "./components/TopSection";
import BottomSection from "./components/BottomSection";
import Header from "Dashboard/components/Header";
import { useCallback, useEffect, useState } from "react";
import { IOutputListItemSearch } from "../../domain/IOutputListItemSearch";
import { getOutputListItems } from "./outputSlice";
import { useAppDispatch } from "hooks/hooks";
import usePagingAndSort,
{ IGetPageRequestParams, IUpdateStateAfterSearchParams } from "hooks/pagingAndSort";
import { useForm } from "react-hook-form";

const Output = () => {
  const dispatch = useAppDispatch();

  const defaultGetOutputListItemsSearchParams: IOutputListItemSearch
    = { searchQuery: undefined, xxx: null };

  const [getOutputListItemsSearchParams, setGetOutputListItemsSearchParams]
    = useState<IOutputListItemSearch>(defaultGetOutputListItemsSearchParams);

  const limit = 200;

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IOutputListItemSearch>({
    defaultValues: defaultGetOutputListItemsSearchParams
  });

  const getStockInputsWithPaging = useCallback((
    pagingParams: IGetPageRequestParams,
    abortSignal: AbortSignal,
    updateStateAfterFetch: (updateStateParams: IUpdateStateAfterSearchParams) => void
  ): void => {
    dispatch(getOutputListItems({
      getOutputListItemsSearchParams,
      pagingParams,
      abortSignal,
      updateStateAfterFetch
    }));
  }, [dispatch, getOutputListItemsSearchParams]);

  const { doSortBy, resetAfterSearch, lastElementRef, handleScroll } =
    usePagingAndSort(
      getStockInputsWithPaging,
      limit,
    );

  useEffect(() => {
    resetAfterSearch();
  }, [getOutputListItemsSearchParams]);

  return (
    <>
      <Header title="Lager - IZLAZ" />
      <Toolbox
        setGetOutputListItemsSearchParams={setGetOutputListItemsSearchParams}
        defaultGetOutputListItemsSearchParams={defaultGetOutputListItemsSearchParams}
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <main className="lager-ex">
        <TopSection
          lastTableElementRef={lastElementRef}
          handleScroll={handleScroll}
        />
        <BottomSection />
      </main>
    </>
  );
};

export default Output;
